import React from 'react';
import { Link } from 'react-router-dom';
import { MOCK_FILMS, MOCK_PROJECTS } from '../mock/data';
import FilmCard from '../components/FilmCard';
import ProjectCard from '../components/ProjectCard';

const Home = () => {
  return (
    <div className="bg-black text-white font-poppins">
      {/* Hero Section */}
      <section className="relative w-full h-screen overflow-hidden">
        {/* Image de fond */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: "url('/images/hero-bg.jpg')" }}
        ></div>

        {/* Texte + Boutons */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-white text-center px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Découvrez et Financez le Cinéma Africain
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mb-6">
            Regardez gratuitement des films africains tout en contribuant au financement des prochains chefs-d'œuvre du continent.
          </p>
          <div className="flex gap-4 flex-wrap justify-center">
            <Link
              to="#films"
              className="border border-karangou-orange text-karangou-orange px-6 py-3 rounded-full hover:bg-karangou-orange hover:text-white transition"
            >
              Découvrir les films
            </Link>
            <Link
              to="#projets"
              className="border border-white text-white px-6 py-3 rounded-full hover:bg-white hover:text-black transition"
            >
              Soumettre un projet
            </Link>
          </div>
        </div>
      </section>

      {/* Films à l'affiche */}
      <section id="films" className="container mx-auto px-4 py-12">
        <h2 className="text-2xl font-bold mb-6">Films à l'affiche</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {MOCK_FILMS.slice(0, 4).map((film) => (
            <FilmCard key={film.id} film={film} />
          ))}
        </div>
        <div className="text-center mt-8">
          <Link to="/films" className="text-amber-600 hover:text-amber-700">
            Voir tous les films
          </Link>
        </div>
      </section>

      {/* Projets à financer */}
      <section id="projets" className="bg-gray-100 text-black py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold mb-6">Projets à financer</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {MOCK_PROJECTS.slice(0, 2).map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
